import ApiJobAgreement from 'types/api/JobAgreement';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import JobAgreement from 'models/JobAgreement';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<JobAgreement>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobAgreements, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobAgreements];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiJobAgreement) => new JobAgreement(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<JobAgreement> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobAgreement, params),
    });

    const data = response?.payload?.data;
    const resource: ApiJobAgreement = data && data[ApiResources.JobAgreement];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new JobAgreement(resource);
};
